module.exports = __webpack_public_path__ + "img/oscleton.e59e6ceb.png";